// format characters to only return id
export const formatCharacters = (characters: any[]) => {
  return characters?.map((char) => char.id);
};

export const formatCharactersObjects = (characterArray, originalArray) => {
  return characterArray.map((character) => {
    return originalArray.find((charObj) => charObj.character === character);
  });
};

export const formatCharactersObjectById = (characterArray, originalArray) => {
  return characterArray.map((character) => {
    return originalArray.find((charObj) => charObj.id === character);
  });
};

export const formatUpdatedUserTeachingOrderSetting = (
  values,
  nextActiveTeachingOrder,
  isCustomOrder,
  productId
) =>
  values?.reduce((acc, curr) => {
    if (curr.productId === productId) {
      acc.push({
        active: {
          id: nextActiveTeachingOrder?.id,
          custom: isCustomOrder,
        },
        productId,
      });
    } else {
      acc.push(curr);
    }
    return acc;
  }, []);

export const determineIfActiveTeachingOrderDisplayed = (
  activeTeachingOrder,
  teachingOrders,
  activeTeachingOrderIndex
) => {
  const savedTeachingOrderIndex = teachingOrders.indexOf(activeTeachingOrder);
  return savedTeachingOrderIndex === activeTeachingOrderIndex;
};
